module.exports = __webpack_public_path__ + "static/b-uti-semi-a91d387bb8971ece374769b9c54b5b6a.jpg";